import React from 'react';
import { ToastConfig, ToastShowParams } from 'react-native-toast-message';
import { Toast } from '../Toast';

export const default_toast_config: ToastConfig = {
  success: ({ text1, text2 }: ToastShowParams) => (
    <Toast title={text1} description={text2} />
  ),

  error: ({ text1, text2 }: ToastShowParams) => (
    <Toast preset="failure" title={text1} description={text2} />
  ),

  info: ({ text1, text2 }: ToastShowParams) => (
    <Toast preset="info" title={text1} description={text2} />
  ),
};
